import { getType } from '@/utils/tool'
import HmacSha256 from 'crypto-js/hmac-sha256'
import { MingTing } from '@/project-subject/subject-config/ming-ting/ming-ting'
import Hex from 'crypto-js/enc-hex'

/**
 * 数字压缩
 * 开n次方根，n即对数，基于最大最小差值计算
 * @param {number} values 值列表
 * @param {number} value 需处理的值
 * @param {number} density 压缩阈值
 */
export function cutNumber (values: number[], value: number, density = 10) {
  const min = Math.min(...values)
  const max = Math.max(...values)
  let logarithm = Math.log(max - min) / Math.log(density)
  logarithm = logarithm || 1 // 避免分母为0的清空
  return Math.pow(Number(value), 1 / logarithm)
}

export function formatTableEmpty (row, column, value: any) {
  const type = getType(value)
  if (
    (type === 'object' && JSON.stringify(value) === '{}') ||
    (type === 'array' && !value.length) ||
    (type === 'string' && !value) ||
    (!value)
  ) {
    return '--'
  }
  return value
}

export function formatMinuteToTime (minute: number) {
  let timeStr = ''
  if (minute) {
    timeStr = `${String(Math.floor((minute / 60))).padStart(2, '0')}:${String(minute % 60).padStart(2, '0') || '00'}`
  }
  return timeStr || '00:00'
}


/**
 * 字节大小计数
 * @param {number} size 大小(byte)
 * @param {number} float 精确度
 * @returns string
 */
export function formatSize (size = 0, float = 0) {
  const sizeBase = 1024

  if (size < sizeBase) {
    return `${size}B`
  }

  const floatBase = 0.1
  // 避免四舍五入后出现返回0, 如输入1Byte，应返回1KB而不是0KB
  const minValue = Number(Math.pow(floatBase, float).toFixed(float))
  const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'BB']
  let unitIndex = 0
  size = Number(size) / sizeBase

  while (size >= sizeBase && unitIndex < units.length - 1) {
    size = size / sizeBase
    unitIndex++
  }

  if (size < minValue) {
    return `${minValue} ${units[unitIndex]}`
  }
  return `${size.toFixed(float)} ${units[unitIndex]}`
}

/**
 * 字节大小计数KB
 * @param {number|string} size 大小(byte)
 * @param {number} float 精确度
 * @returns string
 */
export function formatSizeKb (size: number|string = 0) {
  if (Number.isNaN(Number(size))) {
    return size
  }

  const sizeBase = 1024
  const minValue = 1
  size = Number(size) / sizeBase
  if (size < minValue) {
    return `${minValue} KB`
  }
  return `${Math.round(size).toLocaleString()} KB`
}

/**
 * 格式化path，并将其改成小写，如果结尾有/则去掉
 */
export function formatPath (path: string) {
  if (!path) {
    return ''
  }

  path = path.toLowerCase()
  if (path.endsWith('/')) {
    path = path.slice(0, -1)
  }
  return path
}

export function getVirusMd5 (data: { virus_info: any, md5?: string }) {
  // "计算中"不展示，当成空值处理
  if (data.virus_info.payload.文件MD5?.includes('计算中')) {
    data.virus_info.payload.文件MD5 = ''
  }
  return data.virus_info.payload.文件MD5 || data.md5 || ''
}

/** 密码加密 */
export function passwordHmac (password: string) : string {
  return HmacSha256(password, MingTing.sign_key).toString(Hex)
}

/** 文本溢出 */
export function overflowText (text: string = '', maxLength: number) {
  return text.slice(0, maxLength) + (text.length > maxLength ? '...' : '')
}

export function deepCopy (data) {
  return JSON.parse(JSON.stringify(data))
}
